/* tslint:disable */
import {
  Player,
  Notification
} from '../index';

declare var Object: any;
export interface PlayerNotificationInterface {
  "isEnabled": boolean;
  "id"?: any;
  "playerId"?: any;
  "notificationId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  player?: Player;
  notification?: Notification;
}

export class PlayerNotification implements PlayerNotificationInterface {
  "isEnabled": boolean;
  "id": any;
  "playerId": any;
  "notificationId": any;
  "createdAt": Date;
  "updatedAt": Date;
  player: Player;
  notification: Notification;
  constructor(data?: PlayerNotificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerNotification`.
   */
  public static getModelName() {
    return "PlayerNotification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerNotification for dynamic purposes.
  **/
  public static factory(data: PlayerNotificationInterface): PlayerNotification{
    return new PlayerNotification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerNotification',
      plural: 'player-notifications',
      path: 'player-notifications',
      idName: 'id',
      properties: {
        "isEnabled": {
          name: 'isEnabled',
          type: 'boolean',
          default: true
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "notificationId": {
          name: 'notificationId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        notification: {
          name: 'notification',
          type: 'Notification',
          model: 'Notification',
          relationType: 'belongsTo',
                  keyFrom: 'notificationId',
          keyTo: 'id'
        },
      }
    }
  }
}
